import { baseSchema, Update } from './base'
import { generate } from './generate'
import { z } from 'zod'

export const openaiThreadSchema = z.object({
  id: z.string(),
  metadata: z.object({
    title: z.string().optional(),
  }),
})

/** TODO:
 * 1. Support multiple threads per user
 * 2. Delete all threads on block delete
 */
export const threadSchema = baseSchema.extend({
  userId: z.string(),
  createdAt: z.string(),
  blockId: z.string(),
  openai: openaiThreadSchema,
})

export type AIThread = z.infer<typeof threadSchema>
export type AIThreadUpdate = Update<AIThread>

export const threadBaseOps = generate('thread', threadSchema.parse)
